// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"06c72074","95":"93c4495e","343":"6271a904","382":"4ccf8ed9","736":"5b7e7947","777":"2a791b93","791":"4c9a2a8d","800":"ce90a930","888":"e4bb1e4a","987":"9ba2dd90"}[chunkId] + ".chunk.js";
};